<template>
  <div>
    <div>
      <SheetStatusChip
        :status="sheet.status"
        :status-i18n="sheet.statusI18n"
      />
      <b>{{ sheet.adviceDate }}</b>
    </div>
    <div>
      <b>相談者:</b> {{ sheet.userName }}（ID: {{ sheet.userId }}/{{ sheet.couponName }}） |
      <b>担当者:</b> {{ sheet.doctorName }} |
      <b>対応時間:</b> {{ sheet.startAt }}{{ sheet.endAt }}
    </div>
    <div><b>主訴:</b> {{ sheet.complaint }}</div>
  </div>
</template>

<script>
import SheetStatusChip from "./SheetStatusChip.vue";

export default {
  name: "DaytimeAdviceSheetSummaryRow",
  components: {
    SheetStatusChip
  },
  props: {
    sheet: {
      type: Object,
      required: true
    }
  }
};
</script>
